import { Currency } from '@uniswap/sdk-core'
import { atom } from 'jotai'

/**
 * Route-independent bridge for "select this token into the swap" from the global account drawer.
 *
 * The holdings tray (AccountDrawer/MiniPortfolio) lives OUTSIDE the swap page's SwapAndLimitContext, so
 * it cannot call the swap's currency setter directly, and Robinhood Chain (4663) tokens have no
 * token-details page to route through (Uniswap's backend doesn't index 4663). Instead the tray writes
 * the chosen currency here and navigates to /swap; SwapForm consumes it via `onCurrencySelection`
 * (the exact handler the token selector uses, which already handles cross-chain switching) and clears
 * it. Works regardless of whether the swap page was already mounted.
 */
export const pendingSwapOutputCurrencyAtom = atom<Currency | undefined>(undefined)
